import { Route, Routes } from "react-router-dom";
import FacultyReport from "./UnivDataComponents/FacultyReport";
import UniversitySubjectFacReport from "./UnivDataComponents/UniversitySubjectFacReport";
import UnivwiseReport from "./UnivDataComponents/UnivwiseReport";
import UniversityWiseSubAndFacultyRepo from "./UnivDataComponents/UniversityWiseSubAndFacultyRepo";
import AddUniversityDtls from "./UnivDataComponents/AddUniversityDtls";
import LoginPage from "./UnivDataComponents/LoginPage";
import MainDashboard from "./UnivDataComponents/MainDashboard";
import SubjectWiseFacultyData from "./UnivDataComponents/SubjectWiseFacultyData";
import RusaDashboard from "./UnivDataComponents/Dashboard";
import AddDepartment from "./UnivDataComponents/AddDepartment";
import UniversityFacultyData from "./UnivDataComponents/UniversityFacultyData";
import FacultydetailsEdit from "./UnivDataComponents/FacultydetailsEdit";
import SubjectwiseReport from "./UnivDataComponents/SubjectwiseReport";
import MenuBar from "./UnivDataComponents/MenuBar";
import ChangePassword from "./ChangePassword";
import ForgotPassword from "./ForgotPassword";
import SubjectConsolidatedReport from "./UnivDataComponents/SubjectConsolidatedReport";
import DeptWiseStatusReport from "./UnivDataComponents/DeptWiseStatusReport";


const RoutesComponent = () => (
    <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<MenuBar><MainDashboard /></MenuBar>} />
        <Route path="/Universiyedit" element={<MenuBar><UniversityFacultyData /></MenuBar>} />
        <Route path="/SubjectWiseFacultyData" element={<MenuBar><SubjectWiseFacultyData /></MenuBar>} />
        <Route path="/AddDepartment" element={<MenuBar><AddDepartment /></MenuBar>} />
        <Route path="/FacultyReport" element={<MenuBar><FacultyReport /></MenuBar>} />
        <Route path="/UniversitySubjectFacReport" element={<MenuBar><UniversitySubjectFacReport /></MenuBar>} />
        <Route path="/UnivwiseReport" element={<MenuBar><UnivwiseReport /></MenuBar>} />
        <Route path="/UniversityWiseSubAndFacultyRepo" element={<MenuBar><UniversityWiseSubAndFacultyRepo /></MenuBar>} />
        <Route path="/AddUniversityDtls" element={<MenuBar><AddUniversityDtls /></MenuBar>} />
        <Route path="/SubjectwiseReport" element={<MenuBar><SubjectwiseReport /></MenuBar>} />
        <Route path="/DeptWiseStatusReport" element={<MenuBar><DeptWiseStatusReport /></MenuBar>} />



        <Route path="/SubjectConsolidatedReport" element={<MenuBar><SubjectConsolidatedReport /></MenuBar>} />

        <Route path="/RusaDashboard" element={<RusaDashboard />} />
        <Route path="/UniversityFacultyData" element={<MenuBar><FacultydetailsEdit /></MenuBar>} />
        <Route path="/ChangePassword" element={<MenuBar><ChangePassword /></MenuBar>} />

        <Route path="/ForgotPassword" element={<ForgotPassword />} />
    </Routes>
);

export default RoutesComponent;